module.exports = __webpack_public_path__ + "static/media/active_users.9d53c2be.svg";